<template>
    <!-- TODO: "ml-5" can be deleted as soon as we have the ActionsDropdown on this page! -->
    <v-row>

        <!-- Actions -->
        <ActionDropdown 
            :items="actions"
            context="Shipping"
            alvqa="erp-shipping"
            cols="2"
        /> 

        <!-- Header Stats -->
        <v-col 
            cols="4"
            v-if="totalRecords !== null"
            align-self="center"
            class="v-label theme--light mt-3"
            >
            <BaseHeaderStats context="Shipping" typeStats="LIST" alvqa="erp-shipping-list" />
        </v-col>

        <v-spacer />

        <!-- New Shipping -->
        <v-col 
            xl="2"
            lg="3"
            align-self="end"
            cols="2"
            >
            <BaseButton
                label="lang_ERP_SHIPPING_BUTTON_CAPTION_ADD_NEW_SHIPPING_DOCUMENT"
                :to="{ name: editForm, params: { alvId: 'new' } }"
                block
                color="buttonNewEntity"
                alvqa='erp-shipping-list-button-new'
            />
        </v-col>

    </v-row>    
</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'

export default {
    name: "ShippingTopSlot",
    data() {
        return {
            editForm: "ShippingEdit",
        }
    },
    components: {
        BaseHeaderStats,
        BaseButton,
        ActionDropdown
    },
    computed:{
        totalRecords() { return this.$store.getters.getTotalRecords },
        
        actions() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_PRINT'), 
                    value: 'print',
                    alvqa: this.alvqa + '-list-action-dropdown-print'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_EXPORT'), 
                    value: 'export',
                    alvqa: this.alvqa + '-list-action-dropdown-export'
                },
                {   text: this.$t('lang_GENERIC_ACTION_CREATE_INVOICE'), 
                    value: 'createFromShipping', 
                    alvqa: 'erp-shipping-list-action-dropdown-create-invoice'
                },
                {   text: this.$t('lang_ERP_SHIPPING_ACTION_CREATE_RETURNS_NOTE'), 
                    value: 'createReturnsFromShipping',
                    alvqa: 'erp-shipping-list-action-dropdown-create-returns-note'
                },
                {   text: this.$t('lang_ERP_SHIPPING_ACTION_CREATE_CREDIT_NOTE'), 
                    value: 'createCreditNotesFromShipping', 
                    alvqa: 'erp-shipping-list-action-dropdown-create-credit-note'
                },
                {   text: this.$t('lang_ERP_SHIPPING_ACTION_CREATE_PRO_FORMA'), 
                    value: 'createProForma', 
                    alvqa: 'erp-shipping-list-action-dropdown-create-pro-forma'
                },
                {   text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: 'erp-shipping-list-action-dropdown-delete'
                }
            ]
        }
    }
}
</script>